<template>
   <v-card v-if="listview && Role('lead')" :loading="loading"  flat color="transparent" class="ml-5 mt-5">
                 <!--v-tooltip bottom v-for="(item, n) in delivered">
                      <template v-slot:activator="{ on }">
                           <v-avatar  v-on="on" size="48" color="white" style="border-color:silver;border-size:2px;border-radius:50%;margin-left:-15px" @click="select(item)">
                              <v-img v-if="relation.logo" v-avatar:logo :src="relation.logo"></v-img>
                              <v-img v-if="item._supplier.logo" v-avatar:logo :src="item._supplier.logo"></v-img>
                            </v-avatar>
                          </template>
                      <span>{{item._supplier.name}}</span>
                    </v-tooltip><br>
                    <div>{{selected._supplier.name}}</div>
                 <v-list-item v-if="showUser"   :key="n" v-for="(relation, n) in delivered.filter(q=>q._supplier.name==selected._supplier.name)" :class="{'mb-2': true,'animate': true}" :to="'/track/' + index" style="float:left" dark>
                    <v-icon color="white" v-if="!Role('lead')">navigate_before</v-icon>
                  <v-list-item-avatar class="ma-0 mr-2">
                      <v-img v-if="relation.logo" v-avatar:logo :src="relation.logo"></v-img>
                  </v-list-item-avatar>
        
                  <v-list-item-content class="animate ma-0 pa-0">
                    <v-list-item-title class="white--text" v-html="relation.name"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                 <v-list-item v-else :key="n" v-for="(item, n) in delivered.filter(q=>q._supplier.name!=selected._supplier.name)" :class="{'mb-2': true,'animate': true, 'hidden-text': true}" @click="select(item)" style="float:left">
                  <v-list-item-avatar class="ma-0 mr-2" v-if="item._supplier.logo">
                     <v-img v-if="item._supplier.logo" v-avatar:logo :src="item._supplier.logo"></v-img>
                     <v-icon v-else-if="item.track">all_inclusive</v-icon>
                     <v-icon v-else>home</v-icon>
                     <v-icon v-if="item.modified" style="position:absolute" color="red" large>error_outline</v-icon>
                  </v-list-item-avatar>
        
                  <v-list-item-content class="animate ma-0 pa-0">
                    <v-list-item-title v-html="item._supplier.name"></v-list-item-title>
                    <v-list-item-subtitle v-if="item.track">{{item.track}}: {{tagNames(item.tags).join(', ')}}</v-list-item-subtitle>
                    <v-list-item-subtitle v-else-if="item.event_date" v-html="timeStamp(item.event_date)"></v-list-item-subtitle>
                    <v-list-item-subtitle v-else v-html="item.rating"></v-list-item-subtitle>
                  </v-list-item-content>
                <v-list-item-action v-if="false"><v-btn icon @click="card=-1" style="z-index:10"><v-icon>close</v-icon></v-btn></v-list-item-action>
                </v-list-item-->
  </v-card>
   <v-card v-else-if="listview" :loading="loading"  flat color="transparent" class="ml-5 pl-5 mt-5">
                 <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                           <v-avatar  v-on="on" size="48" color="white" style="border-color:silver;border-size:2px;border-radius:50%;margin-left:-15px" @click="toLink()">
                              <v-img v-if="settings.relation.logo" v-avatar:logo :src="settings.relation.logo"></v-img>
                              <v-img v-else-if="relation.logo" v-avatar:logo :src="relation.logo"></v-img>
                            </v-avatar>
                          </template>
                      <span>{{selected._supplier.name}}</span>
                    </v-tooltip>
                 <v-tooltip bottom v-for="(item, n) in delivered">
                      <template v-slot:activator="{ on }">
                           <v-avatar  v-on="on" size="52" color="white" style="border-color:silver;border-size:2px;border-radius:50%;margin-left:-15px" @click="toLink(item)">
                              <v-img v-if="item._supplier.logo" v-avatar:logo :src="item._supplier.logo" style="border: 2px solid silver;"></v-img>
                              <v-img v-else-if="relation.logo" v-avatar:logo :src="relation.logo"></v-img>
                            </v-avatar>
                          </template>
                      <span>{{item._supplier.name}}</span>
                    </v-tooltip>
                 <!--v-list-item v-if="showUser" :class="{'mb-2': true,'animate': true}" :to="'/track/' + index" style="float:left" dark>
                    <v-icon color="white" v-if="!Role('lead')">navigate_before</v-icon>
                  <v-list-item-avatar class="ma-0 mr-2">
                      <v-img v-if="relation.logo" v-avatar:logo :src="relation.logo"></v-img>
                  </v-list-item-avatar>
        
                  <v-list-item-content class="animate ma-0 pa-0">asdasdasdasd
                    <v-list-item-title class="white--text" v-html="relation.name"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                 <v-list-item v-else :key="n" v-for="(item, n) in delivered" :class="{'mb-2': true,'animate': true, 'hidden-text': true}" :to="toLink(item)">
                  <v-list-item-avatar class="ma-0 mr-2" v-if="item._supplier.logo">
                     <v-img v-if="item._supplier.logo" v-avatar:logo :src="item._supplier.logo"></v-img>
                     <v-icon v-else-if="item.track">all_inclusive</v-icon>
                     <v-icon v-else>home</v-icon>
                     <v-icon v-if="item.modified" style="position:absolute" color="red" large>error_outline</v-icon>
                  </v-list-item-avatar>
        
                  <v-list-item-content class="animate ma-0 pa-0">
                    <v-list-item-title v-html="item._supplier.name"></v-list-item-title>
                    <v-list-item-subtitle v-if="item.track">{{item.track}}: {{tagNames(item.tags).join(', ')}}</v-list-item-subtitle>
                    <v-list-item-subtitle v-else-if="item.event_date" v-html="timeStamp(item.event_date)"></v-list-item-subtitle>
                    <v-list-item-subtitle v-else v-html="item.rating"></v-list-item-subtitle>
                  </v-list-item-content>
                <v-list-item-action v-if="false"><v-btn icon @click="card=-1" style="z-index:10"><v-icon>close</v-icon></v-btn></v-list-item-action>
                </v-list-item-->
  </v-card>
   <v-card v-else :loading="loading"  flat color="transparent">
    
    
     <v-overlay
          :absolute="true"
          :value="loading"
          @click="loading = false"
        >
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    <core-empty v-if="delivered.length==0" icon="list" text="Vragenlijst" description="Zoek een aanvrager om de vragen toe te voegen voor de Case manager"></core-empty>
          <v-container grid-list-lg fluid>
          <masonry
              :cols="cols"
              gutter="10"
              >
              <v-card  v-for="(item, n) in delivered" :class="{'mb-2': true,'animate': true, 'selected-card': card==n}"
              :key="n"  tile transition="slide-x-transition" v-if="card==-1 || card==n" :dark="isMain" :color="isMain ? 'accent':'white'">
                 <v-list-item >
                  <v-list-item-avatar class="ma-0 mr-2" v-if="item._supplier.logo">
                     <v-img v-if="item._supplier.logo && !Role('supplier')" v-avatar:logo :src="item._supplier.logo"></v-img>
                     <v-icon v-else-if="item.track">all_inclusive</v-icon>
                     <v-icon v-else>home</v-icon>
                     <v-icon v-if="item.modified" style="position:absolute" color="red" large>error_outline</v-icon>
                  </v-list-item-avatar>
        
                  <v-list-item-content>
                    <v-list-item-title v-if="Role('supplier')" v-html="item.name"></v-list-item-title>
                    <v-list-item-title v-else v-html="item._supplier.name"></v-list-item-title>
                    <v-list-item-subtitle v-if="item.track">{{item.track}}: {{tagNames(item.tags).join(', ')}}</v-list-item-subtitle>
                    <v-list-item-subtitle v-else-if="item.event_date" v-html="timeStamp(item.event_date)"></v-list-item-subtitle>
                    <v-list-item-subtitle v-else v-html="item.rating"></v-list-item-subtitle>
                  </v-list-item-content>
                <v-list-item-action v-if="card==n"><v-btn icon @click="card=-1" style="z-index:10"><v-icon>close</v-icon></v-btn></v-list-item-action>
                </v-list-item>
                <v-img v-if="false"
                  :src="`https://unsplash.it/150/300?image=${Math.floor(Math.random() * 100) + 1}`"
                  height="150px"
                ></v-img>
                 <v-card-text>
                        <div v-if="help" v-html="help"></div>
                        <div v-else v-html="item.description"></div>
                </v-card-text>
            <v-card-actions v-if="confirmReset == item._id">
                <v-btn text @click="reset(item)" title="verwijderen" color="red">
                  Verwijderen?
                </v-btn>
                <v-btn text @click="confirmReset=null" title="Annuleren">
                  Annuleren
                </v-btn>
            </v-card-actions>
            <v-card-actions v-else>
                 <v-btn icon v-if="Role('lead') && !isMain && item.questions && item.questions && item.questions.length>0" @click="confirmReset=item._id" title="verwijderen">
                  <v-icon>restore</v-icon>
                </v-btn>
                <template v-if="item.questions && item.questions.length>0">
                    <v-icon class="mr-1">list</v-icon>
                    <span class="subheading mr-2">{{item.questions.length}}</span>
                    <v-icon class="mr-1">hourglass_empty</v-icon>
                    
                    <span class="subheading mr-2">{{item.questions.filter(q=>q.duration).reduce((a, b) => +a + +b.duration, 0)}} min</span>
                </template>
                <template v-if="item.answers && item.answers.filter(q=>(q.text && q.text!='') || (q.options && q.options.length>0)).length>0">
                    <v-icon class="mr-1">check</v-icon>
                    <span class="subheading mr-2">{{item.answers.filter(q=>(q.text && q.text!='') || q.options.length>0).length}}</span>
                </template>
                <v-spacer></v-spacer>
                 <v-btn
                 color="accent"
                   @click="download"
                   v-if="isMain && !Role('_supplier')"
                >
                 <v-icon class="mr-2">print</v-icon> Afdrukken
                </v-btn>
                <v-btn v-if="preview && isMain" color="accent" @click="$emit('preview',false)">
                  Aanpassen
                </v-btn>
                <v-btn v-else-if="isMain" color="accent" @click="$emit('preview',true)">
                  Leveranciers
                </v-btn>
                <v-btn text v-else :to="item._type + '/' + item._id">
                  Open
                </v-btn>
                 <!--v-btn text :to="'match/' + item._id + '/5a9905c56fa813001f5e1d61'">
                  Qad
                </v-btn-->
              </v-card-actions>
              </v-card>
            </masonry>
        </v-container>
    </v-card>
</template>

<script>
import {
  mapState, mapActions, mapMutations, mapGetters
} from 'vuex'
import goTo from 'vuetify/es5/services/goto'
export default {
  props: ['mini','listview','context','source', 'index','list','isMain','help'],
   data: () => ({
    all: false,
    confirmReset : null,
    loading : false,
    search: '',
    card:-1,
    scrollPos: 0,
    options: {
          duration: 100,
          easing: 'easeInOutCubic',
        }
 
  }),
  computed: {
    ...mapGetters('auth', ["Role"]),
    ...mapState('auth', ["settings","relation"]),
     ...mapState('match', ['selected']),
     ...mapGetters('match', ["item"]),
       ...mapState('app', ["preview"]),
      showUser(){
        return this.relation._id != this.settings._id  
      },
     cols (){
        var c = (this.isMain) ? 1 : 2
       if (this.delivered.length <= c) c = this.delivered.length
       
       return c
     },
     delivered(){
         console.log(this.list)
         return this.list
     }
  },
  watch: {
      search (value,old) {
        // if (value != '') return this.load()
      },
      card (value){
        if (value > -1) {
            this.scrollPos = window.scrollY
            goTo(0,this.options)
        } else {
            goTo(this.scrollPos,this.options)
        }
      },
      list (value,old){
         
      }
    },
    mounted(){
        
    },
  updated () {
     // console.log(this.list)
      
  },
  methods: {
    
     ...mapMutations('app', ["setMenu","setMini", "setTemplate", "setChat","setPreview"]),
     ...mapActions('match', ['getItem','saveItem', 'setList', 'getList']),
     ...mapMutations('match', ['addAnswer','addListItem',"setSelected"]),
      ...mapActions('auth', ['logout']),
    /* load(force) {
      if (force) this.setList([])
      if (this.loading || !this.settings._id) return false
      var self = this, rating
      var index = self.settings._id
      if (this.index || this.search != '') { //AND ADMIN
        index = this.index
        self.all = true
        rating = ['delivered', 'definitive']
      }
      self.loading =  true
      setTimeout(() => { self.loading = false}, 3000)
      //self.loading = (this.list.length == 0)
      this.cols = 3
      var options = {item: {}, index: index,rating: rating, context:this.context, page_size: 100, source: this.source, q: this.search, next: function(response){
          self.loading = false
          self.cols = self.delivered.length
          if (self.cols > 3) self.cols = 3
          self.$emit('message','Gegevens zijn opgevraagd')
          if (self.context) {
              self.contextlist = response.data
          } else if (self.index){
            self.$nextTick(() => self.select(self.list[0]))  
          } 
          
         // console.log('load list',self.list)
        }}
        console.log('LOAD MATCHES', options)
      this.getList(options)
    },*/
    mainContacts(match){
        if (match._supplier.contacts.filter(c => c.main==true).length == 0) match._supplier.contacts[0]
        return match._supplier.contacts.filter(c => c.main==true)
      },
    timeStamp (date){
        if (!date) return
        var m = this.$moment(date, this.$moment.ISO_8601)
        if (!m.isValid()) return this.$moment().format("dddd D MMMM [om] HH:mm")
        return   m.format("dddd D MMMM [om] HH:mm");
      },
       tagNames (tags){
           if (!tags || !Array.isArray(tags)) return []
         var extra = []
         var tn = tags.filter(q=> q.type=='branche' || q.type=='category' || q.type=='type').map(t => {
            if (t.type == 'category' || t.type == 'type') {
                t.path = t.path.replaceAll(' / ', '###')
                extra.push(t.path.split('/')[0].replaceAll('###',' / '))
                if (t.path.split('/').length > 0) extra.push(t.path.split('/')[1].replaceAll('###',' / '))
            }
            return t.tag
        }) //
        return tn.concat(extra)
      },
      select(item) {
        this.$emit('select', item)  
      },
      toLink (item) {
          console.log(item)
          if (!item || !item._supplier) this.$router.push('/track/' + this.index)
          if (this.Role("lead")) return this.$router.push('/offer/' + item._id)
          return this.$router.push('/track/' + this.index + '/' + item._supplier._id)
      },
      reset (item) {
          this.confirmReset=null
          item.questions = []
          item.answers = []
          this.$emit('save',item)
      },
      download () {
          this.$emit('download')
      }
  },
  sockets: {
        match_update (upd){
           // console.log('match update', upd)
            var q = this.list.filter(item => item._id == upd._id )
            if (q.length == 0) return false
            q = Object.assign(q[0] , upd)
            //this.updateSelected(q)
            q.modified = true
            if (q._user) this.$emit('message', q._user.name + ' heeft de vragenlijst aangepast')
            //this.addListItem(q)
        },
        add_answer (answer) {
            if (answer.owner) this.$emit('message', answer.owner.name + ' heeft een antwoord toegevoegd')
            var q = this.list.filter(item => item._id == answer._id )[0]
            if (!q) return false
            if (!q.answers) q.answers = []
            q.answers.push(answer)
            if (this.seleted && this.seleted._id == answer._id) this.addAnswer(answer)
      }
  }
}
 function compare2( a, b ) {
  var scoreA = a.selected || 0 ,scoreB = b.a || 0
  //if (a.answers) scoreA = a.answers.map(item => (item.score+1) * (item.weight || 1)).reduce((prev, next) => prev + next)
  //if (b.answers) scoreB = b.answers.map(item => (item.score+1) * (item.weight || 1)).reduce((prev, next) => prev + next)
  if ( scoreA < scoreB ){
    return 1;
  }
  if ( scoreA > scoreB ){
    return -1;
  }
  return 0;
}

</script>

<style lang="css">
.max-lines-444444 {
     overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
}
/* styles for '...' */ 
.v-card:not(.selected-card) .max-lines-4 {
  /* hide text if it more than N lines  */
  overflow: hidden;
  /* for set '...' in absolute position */
  position: relative; 
  /* use this value to count block height */
  /* max-height = line-height (1.2) * lines max number (3) */
  
  /* fix problem when last visible word doesn't adjoin right side  */
  text-align: justify;  
  /* place for '...' */
  margin-right: -1em;
  padding-right: 1em;
}
/* create the ... */
.v-card:not(.selected-card) .max-lines-4:before {
  /* points in the end */
  content: '...';
  /* absolute position */
  position: absolute;
  /* set position to right bottom corner of block */
  right: 0;
  bottom: 0;
  margin-left:-10px;
}
/* hide ... if we have text, which is less than or equal to max lines */
.v-card:not(.selected-card) .blockmax-lines-4:after {
  /* points in the end */
  content: '';
  /* absolute position */
  position: absolute;
  /* set position to right bottom corner of text */
  right: 0;
  /* set width and height */
  width: 1em;
  height: 1em;
  margin-top: 0.2em;
  /* bg color = bg color under block */
  background: white;
}
.v-card.animate,
.v-list-item__content.animate{
     -moz-transition: all 1s ease-in-out;
    -o-transition: all 1s ease-in-out;
    -webkit-transition: all 1s ease-in-out;
    transition: all 1s ease-in-out;
}
.v-card.selected-card {
    z-index: 10;
    width: 860px;
    max-width: 900px;
    height: 100vh;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.hidden-text {
    float: left;
}
.hidden-text .v-list-item__content{
    width:0px;
     -moz-transition: all 1s ease-in-out;
    -o-transition: all 1s ease-in-out;
    -webkit-transition: all 1s ease-in-out;
    transition: all 1s ease-in-out;
}
.hidden-text:hover .v-list-item__content{
    width: auto;
}
</style>
